import { tss } from 'tss-react/mui';

export const useCallTypeSelectionStyles = tss.create(({ theme }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    padding: '32px 24px 24px',
  },
  formContainer: {
    width: '100%',
    maxWidth: 400,
  },
  title: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#1f2937',
    marginBottom: '16px',
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  optionBox: {
    padding: '14px 16px',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
  },
  optionContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
  },
  radioButton: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s ease',
    flexShrink: 0,
  },
  radioInner: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#ffffff',
  },
  optionTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1f2937',
    lineHeight: 1.3,
  },
  optionDescription: {
    fontSize: '13px',
    color: '#6b7280',
    lineHeight: 1.3,
  },
  phoneInputContainer: {
    width: '100%',
    maxWidth: 400,
    marginTop: '16px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      fontSize: '14px',
    },
    '& .MuiInputLabel-root': {
      fontSize: '14px',
    },
    '& .MuiFormHelperText-root': {
      fontSize: '12px',
    },
  },
  customerFieldsContainer: {
    marginTop: '16px',
    width: '100%',
    maxWidth: 400,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '12px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      fontSize: '14px',
    },
    '& .MuiInputLabel-root': {
      fontSize: '14px',
    },
  },
  attributesContainer: {
    marginTop: '16px',
    width: '100%',
    maxWidth: 400,
  },
  attributesToggle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  attributesToggleDisabled: {
    cursor: 'default',
    opacity: 0.5,
  },
  attributesToggleText: {
    fontSize: '13px',
    color: '#6b7280',
    marginRight: '2px',
    '&:hover': {
      color: '#374151',
    },
  },
  attributesContent: {
    marginTop: '12px',
  },
  bottomSection: {
    marginTop: 'auto',
    paddingTop: '24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  startButton: {
    minWidth: 220,
    textTransform: 'none' as const,
    fontWeight: 600,
    borderRadius: '8px',
    padding: '10px 32px',
    fontSize: '14px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      opacity: 0.6,
    },
  },
}));
